// extracted by mini-css-extract-plugin
export default {"main":"styles_main__00v6f","title":"styles_title__ZlP0z","faculties":"styles_faculties__UN-es","zoom":"styles_zoom__mLSRU","faculties-mobile":"styles_faculties-mobile__Wxwvy"};